/**
 * useMinistryEdition — single source of truth for "are we on the Ministry
 * white-label edition right now?"
 *
 * Wraps detectEdition() in a memoized hook so every component below the
 * shell can ask the same question without re-parsing window.location on
 * every render. The detection itself is synchronous — the heavy lifting
 * (workspace lookup, role join) happens in useMinistryWorkspace +
 * useMinistryRole.
 */

import { useMemo } from "react";
import { detectEdition } from "@/ministry/lib/edition-detection";

export function useMinistryEdition() {
  return useMemo(() => detectEdition(), []);
}

export function useIsMinistryEdition(): boolean {
  return useMinistryEdition().isWhiteLabel;
}
